// Field-type → renderer registry.
//
// This is the extension point for "addition/deletion of any component must be
// straight forward": a new input type is one `registerField()` call plus a
// component, and every journey config can use it immediately. Nothing in
// SchemaForm needs to change, and no page imports the renderer directly.

import TextInput from "./fields/TextInput";
import SelectInput from "./fields/SelectInput";
import DateInput from "./fields/DateInput";
import ChoiceInput from "./fields/ChoiceInput";
import BooleanInput from "./fields/BooleanInput";
import CurrencyInput from "./fields/CurrencyInput";
import PhoneInput from "./fields/PhoneInput";

/** @type {Record<string, React.ComponentType<*>>} */
const FIELD_TYPES = {
  text: TextInput,
  email: TextInput,
  number: TextInput,
  textarea: TextInput,

  select: SelectInput,
  multiselect: SelectInput,

  date: DateInput,

  radio: ChoiceInput,
  choice: ChoiceInput,

  checkbox: BooleanInput,
  switch: BooleanInput,
  consent: BooleanInput,

  currency: CurrencyInput,
  phone: PhoneInput,
};

/**
 * Register (or replace) a field renderer.
 *
 * @param {string} type       The `type` value journey configs will use.
 * @param {React.ComponentType<*>} component
 *        Receives { field, value, values, error, disabled, onChange, onBlur }.
 *        `onChange` accepts either an event or a bare value.
 */
export const registerField = (type, component) => {
  FIELD_TYPES[type] = component;
};

/** @param {string} type */
export const getFieldComponent = (type) => FIELD_TYPES[type];

export const registeredTypes = () => Object.keys(FIELD_TYPES).sort();

export default FIELD_TYPES;
